import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Stack,
  IStackStyles,
  MessageBar,
  MessageBarType,
  IDropdownOption,
  Image,
  Text,
  ImageFit,
} from '@fluentui/react';

import Header from './Header';
import Sidebar from './Sidebar';
import MessageCourier from '../../../lib/MessageCourier';
import { MessageReceiver } from '../../../lib/MessageReceiver';
import SystemClient from '../../../system/SystemClient';
import { AppContext } from '../../../AppInRouterContext';
// import { AdImages, adImages, imageBackground, USA_PUBLICIDAD } from '../../../common/configurable';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { AdImages, loadConfig } from '../../../common/configurable';
import { Carousel as CarouselNative } from '../Carousel';
import { Alert, Snackbar } from '@mui/material';

const mainStackStyles: Partial<IStackStyles> = {};

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

interface IBaseProps {
  appContext: AppContext;
}

export interface IConfigLayout {
  adImages: AdImages[];
  headerImages: AdImages[];
  headerColor: string;
  imageBackground: string;
  logoHeaderPath: string;
}

interface IBaseState {
  isSidebarOpen: boolean;
  abortController?: AbortController;
  message?: string;
  messageType?: MessageBarType;
  config: IConfigLayout;
}

function lightenHexColor(hex: string, factor = 0.2) {
  // Asegurarnos de que el hex tenga el formato correcto
  const normalizedHex = hex.startsWith('#') ? hex.slice(1) : hex;

  if (normalizedHex.length !== 3 && normalizedHex.length !== 6) {
    throw new Error('El color debe ser en formato hexadecimal (#RGB o #RRGGBB)');
  }

  // Expandir formato corto (#RGB a #RRGGBB)
  const fullHex =
    normalizedHex.length === 3
      ? normalizedHex
          .split('')
          .map((char: string) => char + char)
          .join('')
      : normalizedHex;

  // Convertir a valores RGB
  const r = parseInt(fullHex.slice(0, 2), 16);
  const g = parseInt(fullHex.slice(2, 4), 16);
  const b = parseInt(fullHex.slice(4, 6), 16);

  // Aplicar el factor de "claridad"
  const lighten = (color: any) => Math.min(255, Math.floor(color + (255 - color) * factor));

  const newR = lighten(r);
  const newG = lighten(g);
  const newB = lighten(b);

  // Convertir de vuelta a hexadecimal y retornar
  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB
    .toString(16)
    .padStart(2, '0')}`;
}

class Base extends React.Component<IBaseProps, IBaseState> implements MessageReceiver {
  constructor(props: IBaseProps) {
    super(props);
    this.state = {
      isSidebarOpen: false,
      config: {
        adImages: [],
        headerImages: [],
        headerColor: '#fff',
        imageBackground: '',
        logoHeaderPath: '',
      },
    };
  }

  componentDidMount(): void {
    if (this.props.appContext.courier) {
      this.props.appContext.courier.subscribe(this);
    }

    const fetchConfig = async () => {
      const configData = await loadConfig();
      this.setState({ ...this.state, config: configData });
    };

    fetchConfig();
  }

  receiveError(message: string, _error: unknown): void {
    this.setState({ message, messageType: MessageBarType.error });
    setTimeout(() => {
      this.onDismissMessage();
    }, 30000);
  }

  receiveSuccess(message: string): void {
    this.setState({ message, messageType: MessageBarType.success });
    setTimeout(() => {
      this.onDismissMessage();
    }, 30000);
  }

  private onDismissMessage = () => {
    this.setState({ message: undefined });
  };

  render() {
    const { isSidebarOpen, message, messageType, config } = this.state;
    const backgroundColor = config?.headerColor;
    const backgroundLighterColor = lightenHexColor(config?.headerColor!, 0.15);
    return (
      <div
        style={{
          // backgroundImage: config?.imageBackground ? `url(${config?.imageBackground})` : '',
          backgroundSize: 'cover', // Ajusta la imagen para cubrir todo el contenedor
          backgroundPosition: 'center', // Centra la imagen
          width: '100%', // Ancho del contenedor
        }}
      >
        <Stack
          styles={{
            root: {
              width: '100%',
              margin: '0 auto',
              height: '15 vh',
              alignItems: 'center',
            },
          }}
          className=""
        ></Stack>
        <Stack
          styles={{
            root: {
              width: '100%',
              margin: '0 auto',
              height: '75 vh',
              alignItems: 'center',
              background: config?.imageBackground ? 'transparent' : 'transparent',
            },
          }}
        >
          <section className={'section-container'}>
            {/* {message && (
              <MessageBar
                messageBarType={messageType}
                isMultiline={false}
                onDismiss={this.onDismissMessage}
                dismissButtonAriaLabel="Close"
              >
                {message}
              </MessageBar>
            )} */}
            <Snackbar
              open={!!message}
              autoHideDuration={30000}
              onClose={this.onDismissMessage}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ borderRadius: 0, zIndex: 9999999 }}
            >
              <Alert
                onClose={this.onDismissMessage}
                severity={
                  messageType === MessageBarType.success ? 'success' : MessageBarType.error ? 'error' : 'info'
                }
                sx={{ width: '100%' }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Outlet />
          </section>
        </Stack>
      </div>
    );
  }

  private openSibedar() {
    this.setState({ isSidebarOpen: true });
  }

  private closeSibedar() {
    this.setState({ isSidebarOpen: false });
  }
}
export default Base;
